module.exports = __webpack_public_path__ + "static/img/phone-btn.cee1ec6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion-h5/phone-btn.gif
// module id = YIIv
// module chunks = 2